import styled from '@emotion/styled'
import {
  VERTICAL_ELEMENT_MARGIN_BOTTOM_DESKTOP,
  VERTICAL_ELEMENT_MARGIN_BOTTOM_MOBILE,
} from '../../theme/theme.tsx'
import { BREAKPOINT_MOBILE, useIsPortrait } from '../../util/breakpoints.ts'
import { JSXMapSerializer } from '@prismicio/react'
import { css, Theme } from '@emotion/react'
import { VIEWPORT_HEIGHT } from '../../util/viewportHeight.ts'

export const InlineElementContainer = styled.div`
  ${({ theme }) => {
    const marginLeftRight = theme.inlineElementAlign === 'center' ? 'auto' : '0'

    return `
      display: flex;
      flex-direction: column;
      justify-content: center;
      max-width: ${theme.inlineElementMaxWidth};
    
      margin: 0 ${marginLeftRight} ${VERTICAL_ELEMENT_MARGIN_BOTTOM_DESKTOP} ${marginLeftRight};
      @media ${BREAKPOINT_MOBILE} {
        margin: 0 ${marginLeftRight} ${VERTICAL_ELEMENT_MARGIN_BOTTOM_MOBILE} ${marginLeftRight};
      }
    `
  }}
`

export const InlineTextContainer = styled(InlineElementContainer)`
  justify-content: flex-start;
  max-width: ${({ theme }) => theme.inlineTextMaxWidth};
  padding: 0 ${({ theme }) => theme.inlinePaddingLeftRightDesktop};
  ul,
  ol {
    padding-left: ${({ theme }) => theme.inlinePaddingLeftRightDesktop};
  }
  @media ${BREAKPOINT_MOBILE} {
    max-width: 100%;
    padding: 0 ${({ theme }) => theme.inlinePaddingLeftRightMobile};
  }
`

export const BaseCaption = styled.span`
  ${({ theme }) => {
    const alignSelf =
      theme.inlineElementAlign === 'center' ? 'center' : 'flex-start'

    return `
    font-size: 0.75em;
    font-weight: 300;
    line-height: 1.5;

    width: min(${theme.inlineTextMaxWidth}, 100%);
    align-self: ${alignSelf};

    @media ${BREAKPOINT_MOBILE} {
      width: 100%;
      padding: 0 ${theme.inlinePaddingLeftRightMobile};
    }`
  }}
`

export const InlineCaption = styled(BaseCaption)`
  padding: 0 ${({ theme }) => theme.inlinePaddingLeftRightDesktop};
  ${({ theme }) => theme.inlineCaptionCss}
`

export const ViewportHeightSpace = () => {
  const isPortrait = useIsPortrait()

  if (isPortrait) {
    return <ViewportHeightSpacePortrait />
  } else {
    return <ViewportHeightSpaceLandscape />
  }
}

const ViewportHeightSpacePortrait = styled.div`
  height: calc(${VIEWPORT_HEIGHT} - ${({ theme }) => theme.headerHeightPortrait}px);
`

const ViewportHeightSpaceLandscape = styled.div`
  height: calc(${VIEWPORT_HEIGHT} - ${({ theme }) => theme.headerHeightLandscape}px);
`

// Renders image with original width, but maxWidth 100%
export const inlineImageSerializer: JSXMapSerializer = {
  image: ({ node }) => {
    return (
      <img
        src={node.url}
        alt={node.alt || ''}
        width={node.dimensions.width}
        style={{ maxWidth: '100%' }}
      />
    )
  },
}

// applies scrollstory background to element
export const scrollstoryBackgroundColor = ({ theme }: { theme: Theme }) => css`
  // Important to override dark theme on android devices
  background-color: ${theme.backgroundColor ?? 'white'} !important;

  ${theme.backgroundColorDark
    ? `
    @media (prefers-color-scheme: dark) {
      background-color: ${theme.backgroundColorDark} !important;
    }
  `
    : ''}
`
